<template>
   <div class=" bg-darken" @click="fOutFocus()">
      <!--
      <div v-if="showUpDrugs" class="show-drugs p-3 tx-cl-white">
         <div class="div-center">
            <div>
            <up-drugs-v-310 @outHere="showUpDrugs = false" />
            <br>
            <div class="bg-warning" @click="showUpDrugs = !showUpDrugs">
               @-@
               <br>
               @
            </div>
            </div>
         </div>
      </div>
      -->
      <div v-if="true" class="container up-voucher rounded-2" @click="fOnFocus()" @keyup.esc="fCloseAdd()">
         <!--
         <br>
         {{requestDateValue}}
         <br>
         {{requestDateError}}
         <br>
         {{requestDateErrorRef}}
         <br>
         {{requestDateMeta}}
         <br>
         {{voucherValues}}
         <br>
         {{voucherMeta}}
         <br>
         -->
         <Form class="pt-2" @submit="upVoucher">
         <div class="container pt-2 ">
            <!--
            <div class="row"> -- with search
               <div class="col-10 col-md-5 bg-light tx-cl-black border">
                  etiqueta
               </div>
               <div class="col-12 order-last col-md-5 bg-light tx-cl-black border">
                  input
               </div>
               <div class="col-2 order-md-last bg-light tx-cl-black border">
                  lupa
               </div>
            </div>
            <div class="row"> -- error search
               <div class="col-12 bg-light tx-cl-black border text-end">
                  error
               </div>
            </div>
            <br/>
            <div class="row"> -- component
               <div class="col-12 bg-light tx-cl-black border text-center">
                  componente
               </div>
            </div>
            <br/>
            -- input in two columns
            <div class="row justify-content-between bg-warning">
               <div class=" col-12 col-md-6 p-0 m-0">
                  <div class="col-12 bg-light tx-cl-black border">
                     etiqueta izq
                  </div>
                  <div class="col-12 bg-light tx-cl-black border">
                     input izq
                  </div>
                  <div class="col-12 bg-light tx-cl-black border text-end">
                     error izq error izq error izq error izq error izq error izq error izq
                  </div>
               </div>
               <div class=" col-12 col-md-5 p-0 m-0">
                  <div class="col-12 bg-light tx-cl-black border">
                     etiqueta der
                  </div>
                  <div class="col-12 bg-light tx-cl-black border">
                     input der
                  </div>
                  <div class="col-12 bg-light tx-cl-black border text-end">
                     error der
                  </div>
               </div>
            </div>
            <br/>
            -- input without errors
            <div class="row">
               <div class="col-12 bg-light tx-cl-black border">
                  etiqueta
               </div>
               <div class="col-12 bg-light tx-cl-black border">
                  input
               </div>
            </div>
            -->
            <div class="row">
               <label for="cuil" class="col-10 col-md-4 p-0 text-md-end pe-2"> C.U.I.L. </label>
               <div class="col-12 order-last col-md-6 p-0">
                  <input 
                     v-model="cuilValue" 
                     name="cuil" 
                     type="number" 
                     class="form-control py-0 px-1" 
                     @blur="cuilBlur"
                     @focus="cuilFocus(false)"
                     />
               </div>
               <button 
                  type="button" 
                  class="btn btn-sm col-2 order-md-last p-0 text-end px-2" 
                  data-bs-toggle="modal" 
                  data-bs-target="#searchAffiliate"
                  :data-search-config='`{"options":[{"code":"TXT","label":"Nombre"},{"code":"NUM","label":"Nro.Docum."},{"code":"ID","label":"CUIL"}]}`'
                  >
                  <font-awesome-icon icon="search" class="tx-cl-white"/> 
               </button>
            </div>
            <div class="row">
               <div v-if="cuilMeta.touched || showErrors" class="row p-0 m-0">
                  <i class="error-feedback col-12 col-md-10 text-end p-0 m-0" >{{cuilErrorRef}}</i>
               </div>
            </div>
            <div v-if="showAffilData" class="row pt-2">
               <affiliate-data :dataAffiliate="dataAffil" class="col-12 rounded border text-center"/>
            </div>
            <div class="row justify-content-between">
               <div class=" col-12 col-md-6 p-0 m-0">
                  <label for="requestDate" class="classLabel col-12 px-0 pt-1"> Fecha de Solicitud </label>
                  <input 
                     v-model="requestDateValue" 
                     name="requestDate" 
                     type="date" 
                     class="form-control col-12 py-0 px-1"
                     @blur="requestDateBlur"
                     @focus="requestDateFocus(false)"
                     />
                  <div v-if="!requestDateMeta.valid && (showErrors  || requestDateMeta.touched)" class="col-12 text-end">
                     <i class="error-feedback" >
                        {{requestDateErrorRef}}
                     </i>
                  </div>
               </div>
               <div class=" col-12 col-md-5 p-0 m-0">
                  <label for="tramitNumber" class="classLabel col-12 px-0 pt-1"> Nro de Trámite </label>
                  <input 
                     v-model="tramitNumberValue" 
                     name="tramitNumber" 
                     type="number" 
                     class="form-control p-0 px-1"
                     />
                  <div v-if="false" class="col-12 bg-light tx-cl-black border text-end">
                     error der
                  </div>
               </div>
            </div>

            <div class="row justify-content-between">
               <div class=" col-12 col-md-5 p-0 m-0">
                  <label for="requestDate" class="classLabel col-12 px-0 pt-1"> Teléfono </label>
                  <input v-model="phoneValue" name="phone" type="text" class="form-control p-0 px-1" />
               </div>
               <div class=" col-12 col-md-6 p-0 m-0">
                  <label for="specialty" class="classLabel col-12 px-0 pt-1"> Especialidad </label>
                  <select 
                     v-model="specialtyValue" 
                     name="specialty" 
                     class="form-select p-0 px-1"
                     >
                     <option v-for="(specialty, index) in specialtys" :key="index" :value="specialty.id">
                        {{ specialty.name }}
                     </option>
                     <option :value="0">No Informada</option>
                  </select>
                  <div v-if="false" class="col-12 bg-light tx-cl-black border text-end">
                     error der
                  </div>
               </div>
            </div>

            <div class=" row border-top mt-3"></div>

            <div class="row mt-2">
               <label for="drugs" class="classLabel col-10 px-0 pt-1"> Drogas Prescriptas </label>
               <button 
                  type="button" 
                  class="btn btn-sm col-2 order-md-last p-0 text-end pe-2" 
                  @click="upDrugs()"
                  >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-lg tx-cl-white" viewBox="0 0 16 16">
                     <path fill-rule="evenodd" d="M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2Z"/>
                  </svg>
               </button>
            </div>
            <div class=" row border rounded mt-1 mb-2 p-1">
               <div v-if="showUpDrugs">@@@</div>
            </div>
            <!--
               <up-drugs-v-310 v-if="showUpDrugs"  />
                  @click="showUpDrugs = true"
                  @click="upDrugs()"
               <up-drugs-v-310 v-if="showUpDrugs" @click="showUpDrugs = !showUpDrugs" />
            -->

            <div class="row">
               <label for="doctorsObservations" class="classLabel col-12 px-0 pt-1"> Observaciones Médico </label>
               <textarea
                  v-model="doctorsObservationsValue" 
                  name="doctorsObservations" 
                  type="textarea" 
                  class="form-control col-12 p-0 px-1" 
                  :rows="1"
                  /> 
            </div>

            <div class="row justify-content-between">
               <div class=" col-12 col-md-6 p-0 m-0">
                  <label for="prescriptionDate" class="classLabel col-12 px-0 pt-1"> Fecha Prescripción </label>
                  <input 
                     v-model="prescriptionDateValue" 
                     name="prescriptionDate" 
                     type="date" 
                     class="form-control col-12 py-0 px-1"
                     />
                     <!--
                     @blur="requestDateBlur"
                     @focus="requestDateFocus(false)"
                     -->
                  <div v-if="false" class="col-12 bg-light tx-cl-black border text-end">
                     error izq error izq error izq error izq error izq error izq error izq
                  </div>
               </div>
               <div class=" col-12 col-md-5 p-0 m-0">
                  <label for="medicalRegistration" class="classLabel col-12 px-0 pt-1"> Matrícula </label>
                  <input 
                     v-model="medicalRegistrationValue" 
                     name="medicalRegistration" 
                     type="number" 
                     class="form-control p-0 px-1"
                     />
               </div>
            </div>

            <div class=" row border-top mt-3"></div>

            <div class="row">
               <label for="vouchersObservations" class="classLabel col-12 px-0 pt-1"> Observaciones Voucher </label>
               <textarea
                  v-model="vouchersObservationsValue" 
                  name="vouchersObservations" 
                  type="textarea" 
                  class="form-control col-12 p-0 px-1" 
                  :rows="1"
                  /> 
            </div>
            <!--
            -->
         </div>
            
            <div class="py-3 d-flex justify-content-end">
               <button type="submit" 
                     class="btn btn-outline-light me-1"
                     >
                  Guardar
               </button>
               <button type="button" 
                     class="btn btn-outline-light" 
                     @click="fCloseAdd()"
                     >
                  Salir
               </button>
            </div>
         </Form>
         <!-- 
         {{count}}
            @click="$emit('close')"
      <div class="container new-voucher rounded-2 mt-3">
         class="half-shadow p-3"
         -->
      </div>
   </div>
</template>

<script>

//import { defineComponent } from 'vue';
//import { number } from "yup";import { Field, ErrorMessage } from "vee-validate";
import { ref, onMounted, watch, watchEffect } from 'vue';
import { Form, defineRule, useField, useForm } from "vee-validate";
import { date } from "yup";
//import moment from 'moment';
import AnalyService from "../../analytics/analytics.service";
import V310Service from "/src/modules/voucher310/voucher310.service.js"
import useEventsBus from '/src/services/eventBus';

import AffiliateData from '../../analytics/components/affiliate/AffiliateDataShow.vue';
//import UpDrugsV310 from './UpDrugsV310.vue';

let affilExist = 'N'
async function f( value ) {
   
   let promise = new Promise(( resolve ) => {
      AnalyService.affiliateExists( value )
         .then(response => {
            resolve( response.data )
         })
         .catch(error => {
            console.log(error);
            resolve( error )
         });
   })

   let result = await promise

   affilExist = 'N'
   if ( result == 'N') {
      return 'No hay ningún Afiliado con este CUIL'
   } else {
      affilExist = 'Y'
      if ( result == 'I') {
         return 'No es un Afiliado Activo'
      }
      return true
   }
}
 
defineRule("okCuit", (value) => {
   console.log(value)
   //affilExist = 'N'
   if ( value == undefined ) { return 'Se requiere completar este campo' }
   if ( isNaN(value) ) { return 'Número de CUIL inválido' }
   if ( value < 20000000000 ) { return 'Número de CUIL inválido' }
   if ( value > 40000000000 ) { return 'Número de CUIL inválido' }

   const rslt = f( value )
   return rslt
});

export default {
   name: 'UpVoucher310',
   components: {
      AffiliateData,
      Form
   },

   setup( props, { emit } ) {

      const outFocus = ref(0)
      const cuilRules = 'okCuit'
      const showAffilData = ref(false)
      const dataAffil = ref({})
      
      //const cuil = ref('')
      const cuilErrorRef = ref(null)
      const requestDateErrorRef = ref(null)

      const showUpDrugs = ref(false)

      const specialtys = ref([
         { id: 1 , name: 'Cardilogía' },
         { id: 2 , name: 'Psquiatría' },
         { id: 3 , name: 'Endocrinología' },
         { id: 4 , name: 'Neumonología' }
      ])

      const { 
         values: voucherValues,
         meta: voucherMeta } = useForm();

      const { 
         value: cuilValue, 
         errorMessage: cuilError, 
         meta: cuilMeta,
         handleBlur: cuilBlur,
         setTouched: cuilFocus } = useField('cuil', cuilRules)

      const { 
         value: requestDateValue,
         errorMessage: requestDateError,
         meta: requestDateMeta, 
         handleBlur: requestDateBlur,
         setTouched: requestDateFocus } = useField('requestDate', date()
            /*
            .nullable()
            .transform((curr, orig) => curr === '' ? null : curr)
            */
            .required('La Fecha de Solicitud es Requerida')
            //.max( '2023-09-22', 'La Fecha debe ser menor o igual al día de hoy' )
            //.min( '2023-09-12', 'La Fecha es menor a la requerida' )
            .typeError( 'Fecha Inválida' ) 
            )
                                                      //   .max( (new Date()), 'Fecha Superior a la de Hoy')
                                                      // .required('La Fecha de Solicitud es Requerida'
                                                      // .typeError( 'Fecha Inválida' )


      const { value: phoneValue } = useField('phone')
      const { value: doctorsObservationsValue } = useField('doctorsObservations')
      const { value: tramitNumberValue } = useField('tramitNumber')
      const { value: specialtyValue } = useField('specialty')
      const { value: prescriptionDateValue } = useField('prescriptionDate')
      const { value: medicalRegistrationValue } = useField('medicalRegistration')
      const { value: vouchersObservationsValue } = useField('vouchersObservations')
      
      
      //const toto = ref({"opusday":[{"code":"TXT","label":"por Nombre"},{"code":"NUM","label":"por Nro. de Documento"},{"code":"ID","label":"por CUIL"}]})

      const { bus, emiter } = useEventsBus()
      const count = ref(0)
      const nameAffil = ref(null)

      const showErrors = ref(false)
      const initialValues = ref({ cuil: 27423085083, phone: 'tomates fritos', requestDate: '1959-06-17' })
         //links: [{ id: 1, url: 'https://github.com/logaretm' }],
      //};

      onMounted(() => {
         //console.log('hello voucher!')
         /*
         let toDay = new Date()
         let fromDay = new Date( toDay )
         fromDay.setMonth( fromDay.getMonth() - 10 )
         cuilValue.value = 27423085083
         //requestDateValue.value = moment( fromDay ).format('YYYY-MM-DD');
         cuilFocus(true)
         //requestDateValue.value = '1959-06-17'
         requestDateFocus(true)
         */
         
      })

      watchEffect(() => {         
         //console.log("on out focus: " + outFocus.value)
         if (outFocus.value < 0) {
            outFocus.value = 0
            emit('outFocus')
         }

         cuilErrorRef.value = cuilError.value
         requestDateErrorRef.value = requestDateError.value
      })

      watch( () => cuilMeta.valid, (val) => {
         console.log(val)
         showAffilData.value = false
         if ( val ) {
            getAffiliateBasicData ( cuilValue.value )
         }
      })

      function getAffiliateBasicData ( cuil ) {
         AnalyService.getAffiliateBasicData( cuil )
            .then(response => {
               dataAffil.value = response.data
               showAffilData.value = true
            })
            .catch(error => {
               console.log(error);
               dataAffil.value = error
            });
      }
      
      watch( () => bus.value.get('cuil'), (val) => {
         console.log(val)
         const [toAdd] = val ?? []
         //nameAffil.value.focus()
         console.log(count.value)
         count.value = Number(toAdd)
         //initialValues.value.cuil = Number(toAdd)
         cuilValue.value = Number(toAdd)
         getAffiliateBasicData ( cuilValue.value )
      })

      function allOk( valid, touched, value) {
         console.log(valid)
         console.log(value)
         console.log(affilExist)
         //dataAffil.value = {}
         //showAffilData.value = valid
         showAffilData.value = affilExist == 'Y'
         //if ( (valid && touched) || showAffilData.value ) {
         if ( affilExist == 'Y' ) {
            affilExist = 'N'
            AnalyService.getAffiliateBasicData( value )
               .then(response => {
                  dataAffil.value = response.data
               })
               .catch(error => {
                  console.log(error);
                  dataAffil.value = error
               });
         }
         /*
         if ( !valid && affilExist == 'Y' ) {
            showAffilData.value = true
         }
         */
      }

      function upVoucher() {
         voucherValues.userId = 1
         let voucherData = JSON.stringify(voucherValues)
         console.log(voucherData)
         console.log(JSON.stringify(voucherMeta._value.valid))
         showErrors.value = true
         if ( JSON.stringify( voucherMeta._value.valid ) == 'true' ) {
            showErrors.value = false
            alert(JSON.stringify(voucherValues))
            //
            
            V310Service.updateVoucher(voucherValues)
            .then(response => {
               console.log(response.data)
               emiter('v310ToDo', 'findVouchers')
               emit('closeAdd') 
            })
            .catch(error => {
               console.log(error);
            })
            
            //emiter('v310ToDo', 'findVouchers')
            //
         } else {
            if ( !requestDateValue.value ) {
               console.log(requestDateValue.value)
               requestDateErrorRef.value = 'La Fecha de Solicitud es Requerida'
            }
            if ( !cuilValue.value ) {
               console.log(cuilValue.value)
               cuilErrorRef.value = 'El C.U.I.L. es Requerido'
            }
         }
      }

      function fCloseAdd() { 
         if ( voucherMeta.value.dirty ) {
            if ( confirm( 'Si sale sin Guardar se perderan los datos ingresados.' ) ) {
               emit('closeAdd') 
            }
         } else {
            emit('closeAdd') 
         }
      }

      function fOnFocus() { 
         outFocus.value = outFocus.value + 1
         //console.log("onFocus")
         }

      function fOutFocus() { 
         outFocus.value = outFocus.value - 1
         //console.log("outFocus")
         }

      function upDrugs() {
         showUpDrugs.value = true
         emit('upDrugs')
         //emiter('v310ToDo', 'upDrugs')
      }

      return {
         allOk,
         tramitNumberValue,
         count,
         cuilValue, cuilError, cuilMeta, cuilBlur, cuilFocus, cuilErrorRef,
         cuilRules, dataAffil,
         doctorsObservationsValue,
         fCloseAdd, fOnFocus, fOutFocus,
         medicalRegistrationValue,
         phoneValue,
         prescriptionDateValue,
         voucherValues, voucherMeta,
         initialValues,
         nameAffil,
         outFocus,
         requestDateValue, requestDateError, requestDateMeta, requestDateBlur, requestDateFocus, requestDateErrorRef,
         showAffilData, showErrors, showUpDrugs,
         specialtyValue, specialtys,
         //toto,
         upVoucher, upDrugs,
         vouchersObservationsValue
      }
   },
}

</script>

<style scoped>
   .bg-darken {
      /*background-color: rgba(0, 0, 0, .30);*/
      width: 100%;
      height: 100%;
      /*max-height: calc(95vh - 0px);
      height: calc(100vh - 80px);*/
      position: absolute; 
      top:0;
      left:0
   }
   .up-voucher {
      /*background-color: lightgray;
      background-color: #B3B6B7 ;
      background-color: #512DA8;*/
      background-color: #9E9E9E ;
      margin-top: 10px ;
      max-width: 500px;
      /*width: max-content 200px;
      max-height: calc(85vh - 5px);
      height: calc(100vh - 80px);
      */
      max-height: calc(100vh - 28px);
      overflow-y: auto;
      color: white;
   }
   .error-feedback {
      margin-right: 5px;
      color:red;
   }
   .tx-cl-black {
      color: black;
   }
   .tx-cl-white {
      color: white;
   }
   .w-100 {
      width: 100%;
   }
   .half-shadow {
      background-color: rgba(0, 0, 0, .35);
      height: 100%;
      width: 100%;
      position: absolute; 
      top:0;
      left:0
   }
   div.relative {
      position: relative;
      top: 0;
      left: 0;
      border: 3px solid #8AC007;
      background-color: rgba(0, 0, 0, .35);
   }
   .show-drugs {
      background-color: rgba(0, 0, 0, .35);
      height: 100%;
      width: 100%;
      /*position: absolute; */
      position: fixed; 
      top:0;
      left:0
   }
   .div-center {
      display: flex;
      justify-content: center;
      /*align-items: center;*/
      margin-top: 5vh;
      min-height: 90vh;
   }
</style>